export enum AlertDescription {
  ADVISOR_RETRY = "alertdescription.advisorretry",
  CONTACT_US = "alertdescription.contactus",
  CALL_US = "alertdescription.callus",
  CALL_US_ERROR = "alertdescription.calluserror", //BackendErrorAlert
  CANT_BUY_ONLINE = "alertdescription.cantbuyonline",
  CANT_BUY_ONLINE_GENERAL = "alertdescription.cantbuyonlinegeneral",
  DISCOUNT = "alertdescription.discount",
  EDH_ALERT = "alertdescription.edhalert",
  PRICE_CHECK_FAILED = "alertdescription.pricecheckfailed",
  RESULTS_SHOWN = "description.resultsshown",
  SOMETHING_WENT_WRONG = "alertdescription.somethingwentwrong",
  YOUR_PRICE_CHANGED = "alertdescription.yourpricechanged",
  PHONENUMBER_STOREBRAND = "alertdescription.phonenumber.storebrand",
  PHONENUMBER_DANSKE_BANK = "alertdescription.phonenumber.danskebank",
}

export enum AlertTitle {
  CALL_US = "alerttitle.callus",
  DISCOUNT = "alerttitle.discount",
  EMPTY_CART = "alerttitle.emptycart",
  ERROR_IN_FORM = "alerttitle.errorinform",
  NO_BANK_ID = "alerttitle.nobankid",
  SOMETHING_WENT_WRONG = "alerttitle.somethingwentwrong",
  TOO_YOUNG = "alerttitle.tooyoung",
  WEB_DISCOUNT = "alerttitle.webdiscount",
  YOUR_PRICE_CHANGED = "alerttitle.yourpricechanged",
}

export enum AriaLabel {
  ARROW_UP = "arialabel.svg-arrowup",
  ARROW_DOWN = "arialabel.svg-arrowdown",
  DELETE_BIN = "arialabel.svg-deletebin",
  EDIT = "arialabel.svg-pencil",
  OPEN_DATEPICKER = "arialabel.datepicker.open",
}

export enum Button {
  //Action
  ADD_CAMPAIGN_CODE = "button.action.addcampaigncode",
  ADD_CHILD = "button.action.addchild",
  CANCEL = "button.action.cancel",
  CHECK_PRICE = "button.action.checkprice",
  CLOSE = "button.action.close",
  COMPARE_COVERAGES = "button.action.comparecoverages",
  CONFIRM = "button.action.confirm",
  CONTACT_ADVISOR = "button.action.contactadvisor",
  CONTACT_ME = "button.action.contactpersonal",
  GET_INSURANCE_SUM = "button.action.getinsurancesum",
  GO_TO_SHOPPING_CART = "button.action.gotoshoppingcart",
  LOGIN_BANKID = "button.action.loginbankid",
  LOGIN_WITHOUT_BANKID = "button.action.loginwithoutbankid",
  NO_LOGIN = "button.action.nologin",
  MY_INCIDENTS = "button.action.myincidents",
  NEED_MORE_INSURANCES = "button.action.needmoreinsurances",
  READ_CONDITIONS = "button.action.readconditions",
  READ_LESS = "button.action.readless",
  READ_MORE = "button.action.readmore",
  REGRET_DELETE = "button.action.regretdelete",
  REMOVE = "button.action.remove",
  REMOVE_ALL = "button.action.removeall",
  REPORT_DAMAGE = "button.action.reportdamage",
  RETRY = "button.action.retry",
  SAVE = "button.action.save",
  SAVE_IN_CART = "button.action.saveincart",
  SEARCH = "button.action.search",
  SEARCH_AGAIN = "button.action.searchagain",
  SEE_ALL_INSURANCES = "button.action.seeinsurances",
  SEE_CART = "button.action.seecart",
  SEND_OFFER_ON_EMAIL = "button.action.sendofferonemail",
  UNDO = "button.action.undo",

  //Navigation
  ACCEPT = "button.navigation.acceptorder",
  COMPLETE = "button.navigation.complete",
  CONFIRM_AND_ORDER = "button.navigation.confirm",
  BANK_ID = "button.navigation.bankid",
  LOGIN_AND_ORDER = "button.navigation.loginandorder",
  LOGIN = "button.navigation.login",
  LOGIN_AND_ACCEPT = "button.navigation.loginandacceptorder",
  IDENTIFY_WITH_BANK_ID = "button.navigation.identifywithbankid",
  IDENTIFY_WITHOUT_BANK_ID = "button.navigation.identifywithoutbankid",
  NEXT = "button.navigation.next",
  NIN = "button.navigation.nin",
  ORDER = "button.navigation.order",
  PREVIOUS = "button.navigation.previous",
  RECEIPT = "button.navigation.receipt",
}

export enum Hint {
  DEDUCTIBLE = "hint.deductible",
  VALID_FROM_DATE = "hint.insurancevalidfromdate",
  IS_NORDIC_CITIZEN = "hint.isnordiccitizen",
  PEP = "hint.pep",
  PAYMENT_PERIOD = "hint.paymentperiod",
}

export enum Ingress {
  CREDIT_CHECK_SEND_ELECTRONIC = "ingress.creditchecksendelectronic",
  LOGGED_IN_USER = "ingress.loggedinuser",
  LOGIN_BANKID = "ingress.identifywithbankid",
  LOGIN_WITHOUT_BANKID = "ingress.identifywithoutbankid",
  SEE_BONUS_AND_PRICE = "ingress.seebonusandprice",
  WHO_ARE_YOU = "ingress.whoareyou",
  WHO_ARE_YOU_FORMAL = "ingress.whoareyouformal",
}

export enum Label {
  CITY = "label.city",
  CREDIT_CHECK_SEND_ELECTRONIC = "label.creditchecksendelectronic",
  DEDUCTIBLE = "label.deductible",
  HAS_INSURANCE_IN_OTHER_COMPANY = "label.hasinsuranceinothercompany",
  INSURANCE_VALID_FROM_DATE = "label.insurancevalidfromdate",
  IS_NORDIC_CITIZEN = "label.isnordiccitizen",
  IS_IN_NORWAY_OVER_FIVE_YEARS = "label.isstayinginnorwayformorethanfiveyears",
  PAYMENT_PERIOD = "label.paymentperiod",
  PEP = "label.pep",
  PEP_RECEIPT = "label.pepreceipt",
  POST_NUMBER = "label.postnumber",
  REGISTERED_ADDRESS = "label.registeredaddress",
  TRANSFER_INSURANCE_FROM = "label.transferinsurancefrom",
}

export enum Legal {
  CONSENT_CREDIT_CHECK_ONLINE = "legal.consentcreditcheckonline",
  CONSENT_ON_ORDER = "legal.consentonorder",
  CREDIT_CHECK_ONLINE = "legal.creditcheckonline",
}

export enum LinkCommon {
  BACK_TO_OFFER = "link.navigatebacktooffer",
  SEE_ALL_INSURANCES = "link.seeallinsurances",
  SEE_PRINT_VERSION = "link.seeprintfriendlyversion",
}

export enum CheckoutComponentsCommon {
  PRODUCT_LINKS_STB = "checkoutcomponents.productlinks.url",
  PRODUCT_LINKS_AKA = "checkoutcomponents.productlinks.akaurl",
  PRODUCT_LINKS_COOP = "checkoutcomponents.productlinks.coopurl",
  PRODUCT_LINKS_HUSEIERNE = "checkoutcomponents.productlinks.huseierneurl",
  PRODUCT_LINKS_DANSKE_BANK = "checkoutcomponents.productlinks.danskebankurl",
}

export enum NavBar {
  CART = "navbar.cart",
  MENU = "navbar.menu",
}

export enum OptionLabel {
  BOOLEAN_YES = "optionlabel.booleanyes",
  BOOLEAN_NO = "optionlabel.booleanno",
}

export enum Placeholder {
  CHOOSE = "placeholder.choose",
  CHOOSE_TYPE = "placeholder.choosetype",
  CHOOSE_YEAR = "placeholder.chooseyear",
  PAYMENT_PERIOD = "placeholder.paymentperiod",
}

export enum ShortTitle {
  DEDUCTIBLE = "shorttitle.deductible",
  ISSUE_DATE = "shorttitle.issuedate",
}

export enum Sidebar {
  CONTENT = "sidebar.content",
  HEADING = "sidebar.heading",
}

export enum Subheader {
  SUM_UP_PRICE = "subheaders.sumupyourprice",
  MY_INSURANCE_WEB = "subheaders.myinsuranceweb",
  CHOOSE_COVERAGE = "coveragecard.subheaders.choosecoverage",
}

export enum Table {
  INSURANCE_COUNT_HEADING = "table.insurancecount-heading",
  INSURANCE_COUNT_YEARLY_PRICE = "table.insurancecount-totalcount",
  MONTHLY_PRICE = "table.monthlyprice",
  ONE_TIME_PRICE = "table.onetimeprice",
  TFA = "table.tfa",
  TFA_IS_INCLUDED = "table.tfaisincluded",
  YEARLY_PRICE = "table.yearlyprice",
}

export enum Validation {
  BTA = "validation.bta",
  CHOOSE_DATE = "validation.choosedate",
  DATE_WRONG_FORMAT = "validation.dateofbirth_wrongformat",
  PHONE_MAX = "validation.phone-max",
  PHONE_MIN = "validation.phone-min",
  PHONE_REQUIRED = "validation.phone-required",
  PHONE_SIZE = "validation.phonesize",
  POSTNUMBER = "validation.postnumber",
  POSTNUMBER_INVALID = "validation.postnumber-invalid",
  POSTNUMBER_REQUIRED = "validation.postnumber-required",
  INSURANCE_HOLDER_IS_OWNER_REQUIRED = "validation.insuranceholderisowner",
  RELATION_REQUIRED = "validation.relation_required",
  RELATION_BREAKING_ERROR = "validation.relation_breaking",
  AGE_REQUIRED = "validation.age_required",
  AGE_INVALID = "validation.age_invalid",
}

export enum ValueType {
  AREA = "valuetype.area",
  CONSTRUCTION_YEAR = "valuetype.constructionyear",
  HORSEPOWER = "valuetype.horsepower",
  KM = "valuetype.km",
  LENGTH_FEET = "valuetype.lengthfeet",
  MONTHLY_PRICE = "valuetype.monthlyprice",
  NOK = "valuetype.nok",
  SPEED_KNOP = "valuetype.speedknop",
  SQUARE_METERS = "valuetype.kvm",
  YEARLY_PRICE = "valuetype.yearlyprice",
}

export enum Conjunction {
  AND = "words.conjunction.and",
  OR = "words.conjunction.or",
}
